import templateUrl from './form.html'

/**
 * Add/Edit AppData form component.
 *
 * @type {ngComponent}
 * @prop {TmrResource} resource
 * @prop {string} toast
 */
export const tmrAdminAppDataForm = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrResourceFormController',
  bindings: {
    resource: '<',
    toast: '<',
  },
}
